import { useEffect, useState } from 'react';
import moment from 'moment';
import { calendarRequest, calendarQuery } from '../../services/calendarService.js';

// Fetch only the visible range. Abort obsolete requests when filters or organization change.
export default function useCalendarBlocks({ doctors, teamId, therapistId, locationId, date, view, revision, disabled }) {
  const [blocks, setBlocks] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const doctorIds = doctors.filter(doctor => doctor.isAccessible && (therapistId === 'all' || String(doctor.id) === String(therapistId))).map(doctor => String(doctor.id)).sort().join(',');
  const start = moment(date).startOf(view === 'month' ? 'month' : view === 'week' ? 'week' : 'day').subtract(view === 'month' ? 7 : 0, 'days').toISOString();
  const end = moment(date).endOf(view === 'month' ? 'month' : view === 'week' ? 'week' : 'day').add(view === 'month' ? 7 : 0, 'days').toISOString();
  useEffect(() => {
    setBlocks([]); setError(''); setLoading(false);
    if (disabled || !teamId || !doctorIds) return undefined;
    const controller = new AbortController();
    setLoading(true);
    Promise.all(doctorIds.split(',').map(async doctorId => {
      const result = await calendarRequest(`calendar/busy?${calendarQuery({ doctor_id: doctorId, team_id: teamId, start, end, location_id: locationId === 'all' ? undefined : locationId })}`, { signal: controller.signal });
      return (result.busy || []).map((item, index) => ({
        ...item, id: `unavailable-${doctorId}-${item.id || index}`, doctor_id: doctorId,
        title: 'Unavailable', start: new Date(item.start), end: new Date(item.end), calendarUnavailable: true,
      })).filter(item => Number.isFinite(item.start.getTime()) && Number.isFinite(item.end.getTime()) && item.start < item.end);
    })).then(results => { if (!controller.signal.aborted) setBlocks(results.flat()); })
      .catch(err => { if (!controller.signal.aborted) setError(err.message); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [teamId, doctorIds, locationId, start, end, revision, disabled]);
  return { blocks, error, loading };
}
